/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as SchemaTypes from '../schema/types'

import * as StatementTypes from './types'

export type GetStatementsKey = ['people', string | undefined, 'loans', string | undefined, 'statements', unknown]

export type GetStatementsResponse = StatementTypes.ResponseStatementCollection

export type GetStatementsVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    sortBy?: Array<string>
    year?: string
    includeAllVersions?: boolean
    includeTestVersions?: boolean
    documentDescriptorIds?: Array<SchemaTypes.AnyId>
  }
}

export const getStatements = makeData<GetStatementsResponse, GetStatementsKey, GetStatementsVariables>({
  method: 'get',
  name: 'getStatements',
  summary: 'Get statements',
  path: '/people/{personId}/loans/{loanId}/statements',
  queryKey: ({ query, personId, loanId }) => ['people', personId, 'loans', loanId, 'statements', query],
})

export type UpdateStatementKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'statements',
  string | undefined,
  unknown,
]

export type UpdateStatementResponse = StatementTypes.ResponseStatement

export type UpdateStatementVariables = {
  personId: string | undefined
  loanId: string | undefined
  statementId: string | undefined
  body?: {
    /**
     * Identifier for the document descriptor to be attached to the statement.
     * This value can only be updated if `isCreateAndSendPDF` is set to false on the loan type configuration.
     */
    documentDescriptorId: string
  }
  query?: void
}

export const updateStatement = makeData<UpdateStatementResponse, UpdateStatementKey, UpdateStatementVariables>({
  method: 'put',
  name: 'updateStatement',
  summary: 'Update statement',
  path: '/people/{personId}/loans/{loanId}/statements/{statementId}',
  queryKey: ({ query, personId, loanId, statementId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'statements',
    statementId,
    query,
  ],
})

export type InternalCreateStatementDocumentKey = [
  'companies',
  string | undefined,
  'statements',
  string | undefined,
  'document',
  unknown,
]

export type InternalCreateStatementDocumentResponse = StatementTypes.ResponseStatement

export type InternalCreateStatementDocumentVariables = {
  companyId: string | undefined
  statementId: string | undefined
  body?: void
  query?: void
}

export const internalCreateStatementDocument = makeData<
  InternalCreateStatementDocumentResponse,
  InternalCreateStatementDocumentKey,
  InternalCreateStatementDocumentVariables
>({
  method: 'post',
  name: 'internalCreateStatementDocument',
  summary: 'Create a missing PDF document for an existing statement.',
  path: '/companies/{companyId}/statements/{statementId}/document',
  queryKey: ({ query, companyId, statementId }) => [
    'companies',
    companyId,
    'statements',
    statementId,
    'document',
    query,
  ],
})

export type GetStatementDetailsKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'statements',
  string | undefined,
  'details',
  unknown,
]

export type GetStatementDetailsResponse = StatementTypes.ResponseStatementDetails

export type GetStatementDetailsVariables = {
  personId: string | undefined
  loanId: string | undefined
  statementId: string | undefined
  body?: void
  query?: void
}

export const getStatementDetails = makeData<
  GetStatementDetailsResponse,
  GetStatementDetailsKey,
  GetStatementDetailsVariables
>({
  method: 'get',
  name: 'getStatementDetails',
  summary: 'Get statement details',
  path: '/people/{personId}/loans/{loanId}/statements/{statementId}/details',
  queryKey: ({ query, personId, loanId, statementId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'statements',
    statementId,
    'details',
    query,
  ],
})
